export const WATERMARK_MAX_ROWS = 20;
export const WATERMARK_MAX_COLS = 20;

export function drawTiledImageWatermark(doc, watermarkImage, imgFormat, pageWidth, pageHeight, tileW, tileH, gapX, gapY) {
    const safePageWidth = Math.max(1, Number(pageWidth) || 1);
    const safePageHeight = Math.max(1, Number(pageHeight) || 1);
    const safeTileW = Math.max(1, Number(tileW) || 1);
    const safeTileH = Math.max(1, Number(tileH) || 1);
    const safeGapX = Math.max(1, Number(gapX) || 1);
    const safeGapY = Math.max(1, Number(gapY) || 1);

    try { doc.saveGraphicsState(); doc.setGState(new doc.GState({ opacity: 0.12 })); } catch (e) { }
    for (let row = 0, yy = 0; row < WATERMARK_MAX_ROWS && yy < safePageHeight + safeTileH; row += 1, yy += (safeTileH + safeGapY)) {
        for (let col = 0, xx = 0; col < WATERMARK_MAX_COLS && xx < safePageWidth + safeTileW; col += 1, xx += (safeTileW + safeGapX)) {
            try {
                doc.addImage(watermarkImage, imgFormat, xx - safeTileW * 0.1, yy - safeTileH * 0.1, safeTileW, safeTileH);
            } catch (addErr) {
                try { doc.addImage(watermarkImage, imgFormat, xx, yy, safeTileW * 0.8, safeTileH * 0.8); } catch (e) { }
            }
        }
    }
    try { doc.restoreGraphicsState(); } catch (e) { }
}
